import { atom } from "recoil";

export const userAtom = atom({
	key: 'userAtom',
	default: {
		id: null,
		emailData: {
			email: '',
			emailConfirmed: '',
			confirmationSent: localStorage.getItem('emailConfirmationSent'),
			confirmationSentNow: false,
		},
		firstName: '',
		lastName: '',
		roles: '',
		
	}
});